import { render, staticRenderFns } from "./list-item-nogroup.vue?vue&type=template&id=0b230e52&scoped=true&"
import script from "./list-item-nogroup.vue?vue&type=script&lang=js&"
export * from "./list-item-nogroup.vue?vue&type=script&lang=js&"
import style0 from "./list-item-nogroup.vue?vue&type=style&index=0&id=0b230e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b230e52",
  null
  
)

export default component.exports